import { PrintData } from '@interfaces/print.model';
import { StorageUtilities } from '@utilities/storage.utilities';

export interface PrintMember {
  id: string;
  name: string;
}
export interface MemberSavedProvider extends PrintMember {
  savedProviders: PrintData[];
}
export interface MemberSavedProviderState {
  [memberId: string]: MemberSavedProvider;
}

const storage = new StorageUtilities();
const saved = storage.sessionStorageGet('printData');

export const printDataState = {
  ...saved,
};
